const STORAGE_PREFIX = 'traveldesk-public-restaurant-reservation:';
const memoryKeys = new Map();

function stableValue(value) {
  if (Array.isArray(value)) return value.map(stableValue);
  if (value && typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        if (value[key] !== undefined) result[key] = stableValue(value[key]);
        return result;
      }, {});
  }
  return value;
}

function hash32(value, seed) {
  let hash = seed >>> 0;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  return hash.toString(16).padStart(8, '0');
}

function fingerprint(payload) {
  const canonical = JSON.stringify(stableValue(payload));
  return [
    hash32(canonical, 2166136261),
    hash32(canonical, 2246822507),
    hash32(canonical, 3266489909),
    hash32(canonical, 668265263),
  ].join('');
}

function randomUuid() {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function validUuid(value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
}

export function publicRestaurantReservationIdempotencyKey(payload) {
  const intentFingerprint = fingerprint(payload);
  const storageKey = `${STORAGE_PREFIX}${intentFingerprint}`;
  const memoryKey = memoryKeys.get(storageKey);
  if (validUuid(memoryKey)) return memoryKey;

  if (typeof window !== 'undefined') {
    try {
      const storedKey = window.sessionStorage.getItem(storageKey);
      if (validUuid(storedKey)) {
        memoryKeys.set(storageKey, storedKey);
        return storedKey;
      }
    } catch (error) {
      // Private browsing can deny sessionStorage; the in-memory fence remains active.
    }
  }

  const key = randomUuid();
  memoryKeys.set(storageKey, key);
  if (typeof window !== 'undefined') {
    try {
      window.sessionStorage.setItem(storageKey, key);
    } catch (error) {
      // The in-memory key still protects retries in this page lifecycle.
    }
  }

  return key;
}

export function completePublicRestaurantReservationIntent(payload, completedKey) {
  const storageKey = `${STORAGE_PREFIX}${fingerprint(payload)}`;
  if (memoryKeys.get(storageKey) === completedKey) {
    memoryKeys.delete(storageKey);
  }

  if (typeof window !== 'undefined') {
    try {
      if (window.sessionStorage.getItem(storageKey) === completedKey) {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {
      // A denied sessionStorage does not prevent completing the in-memory intent.
    }
  }
}
